module.exports = __webpack_public_path__ + "static/img/mycelia_256.e49f5dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mycelia_256.png
// module id = i7Eq
// module chunks = 0